<nav class="navbar navbar-light bg-warning">
  <span class="navbar-brand">Administration</span>
  <div class="navbar-nav d-flex flex-row">
    <a class="nav-item nav-link p-1" routerLink="/admin/mongo" routerLinkActive="active">Database</a>
    <a class="nav-item nav-link p-1" routerLink="/admin/districts" routerLinkActive="active">Districts</a>
    <a class="nav-item nav-link p-1" routerLink="/admin/features" routerLinkActive="active">Features</a>
  </div>
  <span class="me-auto"></span>
</nav>
<router-outlet></router-outlet>
